
  import { mapState } from 'vuex'
  import vipSettings from '~/mixins/pages/mission-control/vipSettings'
  export default {
    name: 'Theme3DesktopProfileDropdown',
    mixins: [vipSettings],
    computed: {
      ...mapState({
        player: state => state.player.player
      })
    },
    methods: {
      getLimitNickname(str) {
        if (!str) return null
        if (str.length <= 7) return str
        return `${str.substring(0, 7)}...`
      }
    }
  }
